import React, { Fragment, Component } from 'react';
import { translate } from '../Services/translation';
import FilterOption from './FilterOption';
import ColorFilter from './ColorFilter';

class FacetedSearchConfiguratorGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            showLessItemCount: 5
        };
        this.singleSelect = true;


    }


    render() {
        const { selectedOptions, options } = this.props.group;

        this.selectedOptionPrice = 0;
        if (selectedOptions) {
            const selectedOptionValue = selectedOptions[0];
            if (selectedOptionValue) {
                const selectedOptionItem = options.find(x => x.id === selectedOptionValue);
                if (selectedOptionItem && selectedOptionItem.productItem && selectedOptionItem.productItem.price && selectedOptionItem.productItem.price.price) {
                    this.selectedOptionPrice = selectedOptionItem.productItem.price.price.priceWithVat;
                }
            }
        }
        this.props.group.singleSelect = this.singleSelect;
        const { group, searchFacetChange } = this.props;

        if (group.id === "color") {
            let selectedDisplayName;
            let currency;
            const selectedOptionId = selectedOptions[0];
            if (selectedOptionId) {
                const selectedItem = options.find(x => x.id === selectedOptionId);
                if (selectedItem && selectedItem.productItem) {
                    selectedDisplayName = selectedItem.productItem.colorDisplayName;
                    currency = selectedItem.productItem.currency.symbol;
                }
            }
            return (
                <Fragment>
                    <ul className="faceted-search__color-group" ref="list">
                        <div className="faceted-search__color-group__header" role="faceted-search-item-group">{group.label}</div>
                        <div className="faceted-search__color-group__inner-wrapper">
                            {group.options && group.options.map((item, itemIndex, array) =>
                                <li key={`${item.label}-${itemIndex}`} className="faceted-search__color-item" role="faceted-search-item" ref={itemIndex === this.state.showLessItemCount - 1 ? "showLess" : itemIndex === array.length - 1 ? "showMore" : null}>
                                    <ColorFilter item={item} group={group} searchFacetChange={searchFacetChange} selectedOptionPrice={this.selectedOptionPrice} />
                                </li>
                            )}
                        </div>
                        <div className="faceted-search__color-group__info">
                            <div className="faceted-search__color-group__info__name">
                                {selectedDisplayName}
                            </div>
                            <div className="faceted-search__color-group__info__price">
                                {this.selectedOptionPrice} {currency}
                            </div>
                        </div>
                    </ul>

                </Fragment>
            )
        }
        else {
            return (
                <Fragment>
                    <ul className="faceted-search__group" ref="list">
                        <div className="faceted-search__group-header" role="faceted-search-item-group">{group.label}</div>
                        {group.options && group.options.map((item, itemIndex, array) =>
                            <li key={`${item.label}-${itemIndex}`} className="faceted-search__item" role="faceted-search-item" ref={itemIndex === this.state.showLessItemCount - 1 ? "showLess" : itemIndex === array.length - 1 ? "showMore" : null}>
                                <FilterOption item={item} group={group} searchFacetChange={searchFacetChange} selectedOptionPrice={this.selectedOptionPrice} />
                            </li>
                        )}
                    </ul>
                </Fragment>
            )
        }

    }
}

const FacetedSearchConfigurator = ({ facetFilters, query, searchFacetChange, navigationTheme, cssClass }) => navigationTheme !== 'category' &&
    <ul className="faceted-search">
    {facetFilters && facetFilters.map((group, groupIndex, array) => {
        //group.options.sort((a, b) => a.label > b.label ? 1 : -1);
        const cssColorClass = cssClass || (group.id === "color" ? 'show-for-large' : '');
        return (
            <li key={`${group.label}-${groupIndex}`} className={`faceted-search__item ${cssColorClass}`}>
                 <FacetedSearchConfiguratorGroup group={group} searchFacetChange={searchFacetChange} />
             </li>
       
        )
    })}
    </ul>

export default FacetedSearchConfigurator;
